/*
 * VAYORA — botões "+N hinzufügen" dos avisos de quantidade (snippets/vayora-cart-notice.liquid e bloco de pacotes)
 * e "Hinzufügen" do Passt perfekt dazu (snippets/vayora-cart-upsell.liquid).
 * Adiciona data-vb-qty peças (padrão 1) da variante indicada e atualiza a gaveta/página do carrinho pelo mesmo caminho do tema.
 */
(() => {
  if (window.vayoraCartAdd) return;
  window.vayoraCartAdd = true;

  // Passt perfekt dazu: Farbe/Größe escolhem a variante do botão "Hinzufügen"
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-vu-opt]');
    if (!select) return;
    const card = select.closest('[data-vu]');
    const variants = JSON.parse(card.querySelector('[data-vu-variants]').textContent);
    const chosen = [...card.querySelectorAll('[data-vu-opt]')].map((s) => s.value);
    const variant = variants.find((v) => v.options.every((o, i) => o === chosen[i]));
    const button = card.querySelector('[data-vb-add]');
    button.disabled = !variant || !variant.available;
    button.textContent = button.disabled ? 'Ausverkauft' : 'Hinzufügen';
    if (variant) {
      button.dataset.vbAdd = variant.id;
      card.querySelector('[data-vu-price]').textContent = variant.price;
    }
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-vb-add]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;
    button.disabled = true;

    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));

    try {
      const response = await fetch(`${theme.routes.cart_add_url}`, {
        ...theme.utils.fetchConfig(),
        body: JSON.stringify({ items: [{ id: Number(button.dataset.vbAdd), quantity: Number(button.dataset.vbQty || 1) }], sections }),
      });
      const added = await response.json();
      if (added.status) throw new Error(added.description || added.message);

      const cart = await (await fetch(`${theme.routes.cart_url}`, { ...theme.utils.fetchConfig() })).json();
      cart.sections = added.sections;
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: added } }));
    } catch (error) {
      console.log(error);
      window.location.reload();
    } finally {
      button.disabled = false;
    }
  });
})();
